import { safeStorage } from "../../utils/storage";

// Set when someone comes back from Stripe Checkout. The webhook that marks
// the store as subscribed can land a little later, so for a day this lets the
// Done step show "activating" instead of sending them back to pick a plan.
export const CHECKOUT_RETURNED_KEY = "start:checkoutReturnedAt";
const ONE_DAY = 24 * 60 * 60 * 1000;

export function returnedFromCheckout(search) {
  if (new URLSearchParams(search).get("payment") === "success") return true;
  const at = Number(safeStorage.get(CHECKOUT_RETURNED_KEY));
  return Number.isFinite(at) && at > 0 && Date.now() - at < ONE_DAY;
}
